/**
 * Lucide icons and stroke props shared by the coach profile (`coach-bio`,
 * `coach-profile-*`, flag-gated), `/golf-lessons`, `/coaches/search`, and the
 * offering cards. Meta rows and filters use 16px Lucide glyphs.
 */
import {
  BookOpen,
  Bookmark,
  Calendar,
  CalendarCheck,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleDollarSign,
  CircleUserRound,
  Clock,
  ExternalLink,
  Flag,
  Gift,
  Heart,
  List,
  Lock,
  Map,
  MapPin,
  MapPinned,
  Play,
  SlidersHorizontal,
  Star,
  Tag,
  Trophy,
  User,
  Users,
  X,
} from 'lucide-react'

/** Booking widget select rows (~48px fields). */
export const COACH_PROFILE_FIELD_ICON_PROPS = {
  size: 18,
  strokeWidth: 1.75,
  'aria-hidden': true,
}

/** Booking-card inline MapPinned after location text. */
export const COACH_PROFILE_INLINE_ICON_PROPS = {
  size: 16,
  strokeWidth: 1.5,
  'aria-hidden': true,
}

/** Offering-card meta rows and similar gold glyphs (16×16). */
export const COACH_PROFILE_META_ICON_PROPS = {
  size: 16,
  strokeWidth: 1.75,
  'aria-hidden': true,
}

/** Offering detail dialog meta rows (location, schedule, capacity). */
export const COACH_PROFILE_DIALOG_META_ICON_PROPS = {
  size: 22,
  strokeWidth: 1.75,
  'aria-hidden': true,
}

/** Services shop filter pills (class sets 16×16 on startIcon svg). */
export const COACH_PROFILE_FILTER_ICON_PROPS = {
  strokeWidth: 1.75,
  'aria-hidden': true,
}

export {
  BookOpen,
  Bookmark,
  Calendar,
  CalendarCheck,
  Check,
  ChevronDown,
  ChevronRight,
  ChevronUp,
  CircleCheck,
  CircleDollarSign,
  CircleUserRound,
  Clock,
  ExternalLink,
  Flag,
  Gift,
  Heart,
  List,
  Lock,
  Map,
  MapPin,
  MapPinned,
  Play,
  SlidersHorizontal,
  Star,
  Tag,
  Trophy,
  User,
  Users,
  X,
}
